export enum TopListTableNames {
  TOP_WINS = 'Top wins',
  TOP_WINNERS = 'Top winners',
  TOP_LOSERS = 'Top losers',
}
